import { render, staticRenderFns } from "./manualBkmt.vue?vue&type=template&id=65815a9e"
import script from "./manualBkmt.vue?vue&type=script&lang=js"
export * from "./manualBkmt.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports